import React from "react"
import HighConvertingOffersImage from "../../../../../components/staticQuery/platform/offers/BuildHighConvertingOffers"
import P from "../../../../../components/typography/P"
import BuildGraphic from "../../../../../images/platform/build-campaign.svg"

const DescriptionText = () => (
  <>
    <P>
      Create powerful and intelligent Automation Sequences with Conditional
      Starts and Stops, Email and Text Communication, Actions, Delays and
      Branching.
    </P>
  </>
)

const buildHighConvertingOffersData = {
  titleIcon: BuildGraphic,
  title: "Build High Converting Offers with Ease",
  description: <DescriptionText />,
  graphic: <HighConvertingOffersImage />,
  // imageLeft: false,
  tint: "#F8F2F7",
  textLong: false,
  benefits: [
    {
      benefitTitle: "Easy-to-Use Builder",
      benefitDescription:
        "Build your Offer from scratch or upload a single Image.",
    },
    {
      benefitTitle: "Create Urgency",
      benefitDescription:
        "Set your Offer effective dates for today, next day, by birthday, while supplies last and more.",
    },
    {
      benefitTitle: "Scan a Bar Code",
      benefitDescription:
        "Want to capture Offer redemptions in your POS system?  Add a bar code to make scanning easy.",
    },
    {
      benefitTitle: "Take Action",
      benefitDescription:
        "Update Contacts, Send Notifications, Transfer to Automation Sequences and more.",
    },
  ],
}

export default buildHighConvertingOffersData
